import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { create } from 'kts-scaffold-framework/utils/form';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { Decorators } from 'kts-scaffold-framework/utils/doc';
import {
    Form,
    Input,
    Select,
    Radio,
    Button,
    Row,
    Col,
    Tooltip,
    Card
} from 'antd';

const css = require('./index.scss');
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const TextArea = Input.TextArea;
const Option = Select.Option;

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    type?: number; // 0 => 新增 1 => 查看/修改
    userId?: string;
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const getFieldDecorator = this.props.form.getFieldDecorator;
        const departmentQuery = this.modulesState.departmentQuery ? this.modulesState.departmentQuery : [];
        const type = this.props.type && this.props.type;
        const userInfo = this.modulesState.userInfo ? this.modulesState.userInfo : {};
        if (this.modulesState.refreshEdit) {
            this.props.form.resetFields();
            ModulesAction.updateRefreshEdit(false);
        }
        enum userTypeEnum {
            COMMON_USER = '0',
            COMPANY_ADMIN = '1'
        }

        return (
            <div className={css['editUser']}>
                <Form>
                    <Row type="flex" justify="space-between">
                        <div className={css['typeTitle']}>
                            账号信息
                            <span className={css.tips}>登录手机号及邮箱用于登录FA TMGP。</span>
                        </div>
                        <Col span={11}>
                            <FormItem label="登录手机号" >
                                {
                                    getFieldDecorator('accountPhone', {
                                        rules: [
                                            {
                                                required: false,
                                                message: '请输入登录手机号'
                                            },
                                            { validator: this.checkPhoneEmail }
                                        ],
                                        initialValue: type ? userInfo.accountPhone : undefined
                                    })
                                        (<Input 
                                            // onChange={this.checkPhoneEmail}
                                            disabled={type === 1 && userInfo.isInnerUser === '0'}
                                        />)
                                }
                            </FormItem>
                        </Col>
                        <Col span={11}>
                            <FormItem label="登录邮箱">
                                {
                                    getFieldDecorator('accountEmail', {
                                        rules: [
                                            {
                                                required: false,
                                                message: '请输入登录邮箱'
                                            },
                                            { validator: this.checkPhoneEmail }
                                        ],
                                        initialValue: type ? userInfo.accountEmail : undefined
                                    })
                                        (<Input
                                            disabled={type === 1 && userInfo.isInnerUser === '0'}
                                        />)
                                }
                            </FormItem>
                        </Col>
                        <Col span={11}>
                            <FormItem label="用户姓名">
                                {
                                    getFieldDecorator('nickName', {
                                        rules: [
                                            { required: true, message: '请输入用户名' }
                                        ],
                                        initialValue: type ? userInfo.nickName : undefined
                                    })
                                        (<Input />)
                                }
                            </FormItem>
                        </Col>

                        <div className={css['typeTitle']}>
                            联系方式
                            <span className={css.tips}>用于接收FA TMGP的通知，若未填写则默认使用账号信息。</span>
                        </div>
                        <Col span={11}>
                            <FormItem label="联系手机号">
                                {
                                    getFieldDecorator('phone', {
                                        rules: [{
                                            ...Decorators.phone(),
                                            required: false
                                        }],
                                        initialValue: type ? userInfo.phone : undefined
                                    })
                                        (<Input />)
                                }
                            </FormItem>
                        </Col>
                        <Col span={11}>
                            <FormItem label="联系邮箱">
                                {
                                    getFieldDecorator('email', {
                                        rules: [{
                                            ...Decorators.email(),
                                            required: false
                                        }],
                                        initialValue: type ? userInfo.email : undefined
                                    })
                                        (<Input />)
                                }
                            </FormItem>
                        </Col>
                        <div className={css['typeTitle']}>身份信息</div>
                        <Col span={24}>
                            <FormItem label="角色">
                                <div id="groupIdss">
                                    {
                                        getFieldDecorator('groupIds', {
                                            rules: [
                                                { required: false, message: '请选择角色' },
                                            ],
                                            initialValue: this.modulesState.selectedJob&&this.modulesState.selectedJob.length?this.modulesState.selectedJob[0]:''
                                        })
                                            (<Select
                                                // onChange={this.changeIsInnerUser}
                                                optionFilterProp="children"
                                                showSearch={true}
                                                getPopupContainer={() => window.document.getElementById('groupIdss')}
                                                allowClear={true}
                                            >
                                                {
                                                    this.modulesState.jobList &&
                                                    this.modulesState.jobList.map(element => <Option key={element.roleCode}>{element.roleName}</Option>)
                                                }
                                            </Select>)
                                    }
                                </div>
                            </FormItem>
                        </Col>
                        <Col span={11}>
                            <FormItem label="所属部门">
                                <div id="departmentss">
                                    {
                                        getFieldDecorator('departmentId', {
                                            rules: [
                                                { required: true, message: '请选择部门' }
                                            ],
                                            initialValue: type ? userInfo.departmentId : this.setupDefaultDepartment()
                                        })
                                            (<Select
                                                showSearch={true}
                                                getPopupContainer={() => window.document.getElementById('departmentss')}
                                                filterOption={(inputValue, option) => { return (option.props.title + '').indexOf(inputValue) !== -1; }}
                                            >
                                                {departmentQuery.map(department =>
                                                    <Option key={department.departmentId} title={department.name}><Tooltip title={department.name}>{department.name}</Tooltip></Option>
                                                )}
                                            </Select>)
                                    }
                                </div>
                            </FormItem>
                        </Col>
                        <Col span={11}>
                            <FormItem label="用户类型">
                                {
                                    getFieldDecorator('isInnerUser', {
                                        rules: [
                                            { required: true, message: '请选择用户类型' },
                                            { validator: this.checkPhoneEmail }
                                        ],
                                        initialValue: type ? userInfo.isInnerUser : '1'
                                    })
                                        (<Select
                                            disabled={type === 1}
                                            onChange={this.changeIsInnerUser}
                                        >
                                            <Option key="1">内部员工</Option>
                                            <Option key="0">外部员工</Option>
                                        </Select>)
                                }
                            </FormItem>
                        </Col>
                        <Col span={11}>
                            <FormItem label="用户角色">
                                {
                                    getFieldDecorator('isAdminType', {
                                        initialValue: type ? userTypeEnum[userInfo.userType] : '0'
                                    })
                                        (
                                            <RadioGroup
                                                disabled={!this.modulesState.isInnerUserControl}
                                            >
                                                <Radio value="1">管理员</Radio>
                                                <Radio value="0">普通用户</Radio>
                                            </RadioGroup>
                                        )
                                }
                            </FormItem>
                        </Col>
                        <Col span={11}>
                            <FormItem label="是否为公开联系人">
                                {
                                    getFieldDecorator('isContactor', {
                                        initialValue: type ? userInfo.isContactor : false
                                    })
                                        (
                                            <RadioGroup
                                                onChange={this.isContactor}
                                                disabled={!this.modulesState.isInnerUserControl}
                                            >
                                                <Radio value={true}>是</Radio>
                                                <Radio value={false}>否</Radio>
                                            </RadioGroup>
                                        )
                                }
                            </FormItem>
                        </Col>
                        {
                            this.modulesState.isContactorView ?
                                (
                                    <Row type="flex" justify="space-between">
                                        <Col span={11}>
                                            <FormItem label="公开职务">
                                                {
                                                    getFieldDecorator('pubPost', {
                                                        rules: [
                                                            { required: true, message: '请输入公开职务' }
                                                        ],
                                                        initialValue: type ? (userInfo.contactorInfo && userInfo.contactorInfo.userPost) : undefined
                                                    })
                                                        (<Input />)
                                                }
                                            </FormItem>
                                        </Col>
                                        <Col span={11}>
                                            <FormItem label="公开电话">
                                                {
                                                    getFieldDecorator('pubPhone', {
                                                        initialValue: type ? (userInfo.contactorInfo && userInfo.contactorInfo.phone) : undefined
                                                    })
                                                        (<Input />)
                                                }
                                            </FormItem>
                                        </Col>
                                        <Col span={24}>
                                            <FormItem label="公开邮箱">
                                                {
                                                    getFieldDecorator('pubEmail', {
                                                        initialValue: type ? (userInfo.contactorInfo && userInfo.contactorInfo.email) : undefined
                                                    })
                                                        (<Input />)
                                                }
                                            </FormItem>
                                        </Col>
                                    </Row>
                                ) : undefined
                        }
                        <Col span={24}>
                            <FormItem label="备注">
                                {
                                    getFieldDecorator('description', {
                                        initialValue: type ? userInfo.description : undefined,
                                        rules: [
                                            {
                                                max: 200, message: '备注不能超过两百个字'
                                            }
                                        ]
                                    })
                                        (<TextArea
                                            placeholder="这家伙很懒，什么都没有留下"
                                            style={{ padding: '18px 12px' }}
                                            rows={3}
                                            onChange={this.changeMsg}
                                        />)
                                }
                                {
                                    <span style={{ float: 'right' }}>共{this.modulesState.descriptionMsg.length}/200</span>
                                }
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
                <div className={css['editUser-hander']}>
                    {
                        type ?
                            (
                                <Button
                                    className={`${css['dispatch-common-green']} ${css['dispatch-common-height']}`}
                                    type="primary"
                                    onClick={this.updateUserInfo}
                                >修改
                                </Button>
                            ) :
                            (
                                <Button
                                    className={`${css['dispatch-common-green']} ${css['dispatch-common-height']}`}
                                    type="primary"
                                    onClick={this.createUser}
                                >新增
                                </Button>
                            )
                    }
                    <Button
                        className={`${css['dispatch-common-sliver']} ${css['dispatch-common-height']}`}
                        onClick={this.closeEdit}
                    >关闭
                    </Button>
                </div>
            </div>
        );
    }

    private createUser = () => {
        this.props.form.validateFields((err, val) => {
            if (!err && this.checkPhoneEmail()) {
                const domain = window.location.origin;
                const options = Object.assign({}, val, { domain });
                ModulesAction.createUser(options);
            }
        });
    }

    private updateUserInfo = () => {
        this.props.form.validateFields((err, val) => {
            if (!err && this.checkPhoneEmail()) {
                const domain = window.location.origin;
                const options = Object.assign({}, val, { domain }, { userId: this.props.userId });
                ModulesAction.updateUserInfo(options);
            }
        });
    }

    private isContactor = (e) => {
        ModulesAction.updateIsContactorIvew(e.target.value);
    }

    private hideAside = () => {
        // MyStore.instance.dispatch(reducers.aside.ActionTypes.hide, null);
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.remove, null);
    }

    private closeEdit = () => {
        ModulesAction.updateIsContactorIvew(false);
        this.hideAside();
    }

    private preCheck = async (rule, value, callback) => {
        if (!this.props.type) {
            const isInnerUser = this.props.form.getFieldValue('isInnerUser');
            const val = this.props.form.getFieldValue('email');
            const res = await ModulesAction.preCheck({
                isInnerUser,
                email: val
            });
            if (res && !res.result) {
                callback(res.message);
            } else {
                callback();
            }
        }
    }
    /**
     * 检验 登录邮箱/手机号码/员工类型 是否合规
     */
    private checkPhoneEmail = async () => {
        const type = this.props.type && this.props.type;
        // 修改时候不校验
        if (type) {
            return true;
        }
        const isInnerUser = this.props.form.getFieldValue('isInnerUser');
        const accountPhone = this.props.form.getFieldValue('accountPhone');
        const accountEmail = this.props.form.getFieldValue('accountEmail');
        const res: any = await ModulesAction.preCheck({
            isInnerUser,
            accountPhone,
            accountEmail,
        });
        if (res && !res.result) {
            this.setFormErr(res.errorMsg);
            return false;
        } else {
            this.clearFormErr();
            return true;
        }
    }
    /** 
     * 对应表单提示错误
     */
    private setFormErr = (errorMsg) => {
        if (!errorMsg) {
            return;
        }
        const accountPhone = this.props.form.getFieldValue('accountPhone');
        const accountEmail = this.props.form.getFieldValue('accountEmail');

        setTimeout(() => {
            this.props.form.setFields({
                accountPhone: {
                    value: accountPhone,
                    errors: errorMsg.phoneMsg ? [new Error(errorMsg.phoneMsg)] : null,
                }
            });

            this.props.form.setFields({
                accountEmail: {
                    value: accountEmail,
                    errors: errorMsg.emailMsg ? [new Error(errorMsg.emailMsg)] : null,
                }
            });
        }, 0);
    }
    /** 
     * 清空对应表单提示错误
     */
    private clearFormErr = () => {
        const accountPhone = this.props.form.getFieldValue('accountPhone');
        const accountEmail = this.props.form.getFieldValue('accountEmail');

        setTimeout(() => {
            this.props.form.setFields({
                accountPhone: {
                    value: accountPhone,
                    errors: null,
                }
            });

            this.props.form.setFields({
                accountEmail: {
                    value: accountEmail,
                    errors: null,
                }
            });
        }, 0);
    }

    private changeMsg = e => {
        ModulesAction.updateDescriptionMsg(e.target.value);
    }

    private setupDefaultDepartment = () => {
        const departments = this.modulesState.departmentQuery.filter(ele => {
            return ele.number === '001';
        });
        return departments[0].departmentId;
    }

    private validatorEmail = (rule, value, callback) => {
        const email = this.props.form.getFieldValue('email');
        if (email !== undefined && email !== '') {
            this.props.form.validateFields(['email'], { force: true }, () => { });
        }
        callback();
    }

    private changeIsInnerUser = (isInnerUser) => {
        if (isInnerUser === '0') {
            ModulesAction.updateIsInnerUserControl(false);
            this.props.form.setFieldsValue({
                isAdminType: '0',
                isContactor: false
            });
            ModulesAction.updateIsContactorIvew(false);
        } else {
            ModulesAction.updateIsInnerUserControl(true);
        }
    }

}



// WEBPACK FOOTER //
// ./src/display/platform/UserManage/UI.Edit.tsx